import { Component, Input, OnInit } from '@angular/core';
import { ProducerModel } from '@bo-client/activation-management/grid-registration/model/producer.model';

@Component({
  selector: 'app-producers-summary',
  templateUrl: './producers-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class ProducersSummaryComponent implements OnInit {
  @Input() producers: ProducerModel[] = [];
  @Input() consumptionOver30kw: boolean;
  @Input() showOnlyTotal = false;

  constructor() {}

  ngOnInit(): void {}
}
